import { Box, List } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { StyledListItem } from './styled';

/**
 * Skeleton loader components for the BaseDropdown
 */

// Skeleton-specific constants
const DEFAULT_SKELETON_COUNT = 5;
const SKELETON_HEIGHT = 20;
const SKELETON_ICON_SIZE = 24;
const LIST_ITEM_MARGIN = '0px 10px';

export interface SkeletonLoaderProps {
  /** Number of skeleton items to display */
  count?: number;
}

/**
 * Skeleton placeholder for individual list items during loading
 */
const SkeletonListItem = () => (
  <StyledListItem button>
    <Box style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <Box style={{ margin: LIST_ITEM_MARGIN, flex: 1 }}>
        <Skeleton variant="text" height={SKELETON_HEIGHT} width="80%" />
      </Box>
      <Skeleton
        variant="text"
        width={SKELETON_ICON_SIZE}
        height={SKELETON_ICON_SIZE}
      />
    </Box>
  </StyledListItem>
);

/**
 * Loading skeleton component that displays multiple placeholder items
 *
 * @param count - Number of skeleton items to render (default: 5)
 */
export const SkeletonLoader = ({
  count = DEFAULT_SKELETON_COUNT
}: SkeletonLoaderProps) => (
  <List component="ul" aria-label="Loading options">
    {Array.from({ length: count }, (_, index) => (
      <SkeletonListItem key={index} />
    ))}
  </List>
);
